var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTxt = function SvgTxt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "-3 -3 26 26"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 13,
    fill: "#30CB22"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.668 14.167h6.667M6.668 10.833h3.333M10.832 2.083V2.5c0 2.357 0 3.535.732 4.268s1.911.732 4.268.732h.417m.416 1.38v2.787c0 3.142 0 4.714-.976 5.69s-2.548.976-5.69.976-4.714 0-5.69-.976c-.977-.976-.977-2.548-.977-5.69V7.88c0-2.704 0-4.056.738-4.972q.225-.279.503-.503c.916-.738 2.268-.738 4.972-.738.588 0 .882 0 1.151.095q.084.03.165.068c.257.123.465.33.88.747l3.948 3.947c.482.481.723.722.85 1.029.126.306.126.646.126 1.328"
  })));
};
export default SvgTxt;